import React from 'react';

const MutedStatus = ({ status }: { status: string }) => {
  return <span className="muted-status">{status}</span>;
};

export default MutedStatus;
